<template>
  <b-modal v-model="active" size="xl" centered hide-footer no-close-on-backdrop body-class="p-0" @hidden="reset">
    <template #modal-title>{{ $t("Service") }}</template>
    <div v-if="active">
      <provider-service-table v-bind:filter="filter"/>
    </div>
  </b-modal>
</template>

<script>
import ProviderServiceTable from "@/components/tables/ProviderServiceTable.vue";

const filterDefaults = {providerId: null, statuses:null,contact:null, serviceTime: {start: null, end: null}};
export default {
  name: "ProviderServicesTableModal",
  components: {ProviderServiceTable},
  data() {
    return {
      active: false,
      filter: {providerId: null, statuses:null,contact:null, serviceTime: {start: null, end: null}},
    };
  },
  methods:{
    show(filter) {
      this.filter = {...filterDefaults, ...(filter || {})};
      this.active = true;
    },
    reset() {
      this.active = false;
      this.filter = {providerId: null, statuses: null, contact: null, serviceTime: {start: null, end: null}};
    }
  }
}
</script>



<style scoped>

</style>